import "./filter_collapse_wrapper.less";
import React from "react";

import { clsx } from "@src/utils/helper";
import { Collapse, CollapseProps } from "antd";

interface FilterCollapseWrapperProps {
  isDataStatic?: boolean;
  title: string;
  children: React.ReactNode;
  search?: React.ReactNode;
}

const FilterCollapseWrapper: React.FC<FilterCollapseWrapperProps> = ({
  isDataStatic,
  title,
  children,
  search,
}) => {
  const panels: CollapseProps["items"] = [
    {
      key: title,
      label: title,
      children: (
        <div className="filter-panel">
          {search && <div className="filter-panel__border">{search}</div>}
          <div
            className={clsx(
              "filter-panel__content",
              isDataStatic && "filter-panel__content--static"
            )}
          >
            {children}
          </div>
        </div>
      ),
    },
  ];
  return (
    <Collapse
      defaultActiveKey={title}
      expandIconPosition="end"
      className="filter-collapse-wrapper"
      data-testid="filter-collapse-wrapper"
      items={panels}
    />
  );
};

export default FilterCollapseWrapper;
